import i18next from "i18next"

import dateService from "services/date"

export const getSteps = (bike) => {
    const bikePortabilityRequestDate = bike?.modify_date

    // Add 1 day to the requested date
    // We use date-fns to add 1 day. Prevent time zone change
    const bikeTransferRequestExpiredDate = dateService.addDays(dateService.getDate(bikePortabilityRequestDate), 1)

    //const formattedTransferRequestResponseDate = bikeTransferRequestResponseDate && dateService.formatDate(bikeTransferRequestResponseDate, stringFormat)
    const formattedTransferRequestExpiredDate = bikePortabilityRequestDate && dateService.formatDate(bikeTransferRequestExpiredDate, dateService.getCurrentDateFormat(), false)

    return [
        {
            id: "SEND",
            label: i18next.t("back_and_buy.send_status", { ns: "bike" }),
            date: bikePortabilityRequestDate && dateService.formatDate(bikePortabilityRequestDate, dateService.getCurrentDateFormat())
        },
        {
            id: "WAITING",
            label: i18next.t("back_and_buy.waiting_status", { ns: "bike" }),
        },
        {
            id: "ACCEPTED",
            label: i18next.t("portability.confirmed_status", { ns: "bike" }),
            isDisabled: true,
        },
        {
            id: "EXPIRED",
            label: i18next.t("back_and_buy.expired_status", { ns: "bike" }),
            date: bikePortabilityRequestDate && formattedTransferRequestExpiredDate,
            isActive: true
        },
    ]
}